function routes($stateProvider) {
    $stateProvider
        .state("evaluation.newBasicInfo", {
            name: "newBasicInfo",
            url: "/basic-info",
            views: {
                content: { template: "<step-basic-info></step-basic-info>" },
            },
        })
        .state("evaluation.basicInfo", {
            name: "basicInfo",
            url: "/:id/basic-info",
            views: {
                content: { template: "<step-basic-info></step-basic-info>" },
            },
        })
        .state("evaluation.learningGoals", {
            name: "learningGoals",
            url: "/:id/learning-goals",
            views: {
                content: {
                    template: "<step-learning-goals></step-learning-goals>",
                },
            },
        })
        .state("evaluation.learningEngagement", {
            name: "learningEngagement",
            url: "/:id/learning-engagement",
            views: {
                content: {
                    template:
                        "<step-learning-engagement></step-learning-engagement>",
                },
            },
        })
        .state("evaluation.pedagogicalApproach", {
            name: "pedagogicalApproach",
            url: "/:id/pedagogical-approach",
            views: {
                content: {
                    template:
                        "<step-pedagogical-approach></step-pedagogical-approach>",
                },
            },
        })
        .state("evaluation.pedagogicalApproach.subjectArea", {
            name: "subjectArea",
            url: "/subject-area",
            views: {
                content: {
                    template:
                        "<pedagogical-approach-area></pedagogical-approach-area>",
                },
            },
        })
        .state("evaluation.pedagogicalApproach.defaultSubjectArea", {
            name: "defaultSubjectArea",
            url: "/:subjectAreaId",
            views: {
                content: {
                    template:
                        "<pedagogical-approach-area></pedagogical-approach-area>",
                },
            },
        })
        .state("evaluation.conclusions", {
            name: "conclusions",
            url: "/:id/conclusions",
            views: {
                content: { template: "<step-conclusions></step-conclusions>" },
            },
        })
        .state("evaluation.gdpr", {
            name: "gdpr",
            url: "/:id/gdpr",
            views: {
                content: { template: "<step-gdpr></step-gdpr>" },
            },
        })
        .state("evaluation.publish", {
            name: "publish",
            url: "/:id/publish",
            views: {
                content: { template: "<step-publish></step-publish>" },
            },
        });
}

routes.$inject = ["$stateProvider"];

export default routes;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/evaluationRoutes.js